import styled from '@emotion/styled';

export const TopSection = styled.div`
  display: flex;
  flex-direction: column;
  align-items: stretch;
  gap: 12px;
  margin-bottom: 12px;

  @media (min-width: 769px) {
    flex-direction: row;
    align-items: flex-start;
    justify-content: space-between;
    gap: 32px;
    margin-bottom: 24px;
    padding: 0;
  }
`;

export const Intro = styled.div`
  flex: 0 0 auto;
  width: 100%;
  padding-top: 0;

  @media (min-width: 769px) {
    flex: 0 0 34%;
    max-width: 420px;
    padding-top: 4px;
  }
`;

export const BannerWrap = styled.div`
  width: 100%;
  min-width: 0;

  @media (min-width: 769px) {
    flex: 1 1 0;
    max-width: 58%;
  }
`;
